module.exports = __webpack_public_path__ + "static/maps_big-b4a7e9370823384c3478179c3ecdc7c7.jpg";